<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h3 style="text-align: center">หนังสือรับรองการหักภาษี ณ ที่จ่าย</h3>
            <div class="row">
                <div class="form-group col-6 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">ชื่อ</label>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.customer"
                            :options="optionCustomer"
                            track-by="id"
                            :customLabel="customWithName"
                            :show-labels="false"
                            placeholder="เลือกลูกค้า">
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-6 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">ประเภท</label>
                    <div class="col-4 pt-2">
                        <input type="radio" v-model="form.type" id="3" value="3">
                        <label for="3">ภ.ด.ง. 3</label>
                    </div>
                    <div class="col-4 pt-2">
                        <input type="radio" v-model="form.type" id="53" value="53">
                        <label for="53">ภ.ด.ง. 53</label>
                    </div>
                </div>
                <div class="col-6 text-right">
                    <button @click="clearDate()"
                            class="btn btn-danger my-2 my-sm-0"
                            type="button">
                        เคลียร์วันที่
                    </button>
                </div>
            </div>
            <div class="row">
                <table width="100%">
                    <tr>
                        <td width=""></td>
                        <td rowspan="2" width="55%">ประเภทเงินได้พึงประเมิณที่จ่าย</td>
                        <td>วัน เดือน</td>
                        <td rowspan="2">จำนวนเงินที่จ่าย</td>
                        <td>ภาษีที่หัก</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>หรือปีภาษี ที่จ่าย</td>
                        <td>และนำส่งไว้</td>
                    </tr>
                    <tr v-for="(x,i) in tax_list">
                        <input type="text" hidden v-model="form.tax[i].index = x.id">
                        <td style="vertical-align: top" class="pt-1">{{ !x.space ? x.order : '' }}</td>
                        <td class="text-left" :class="{ 'pad-left-1' : x.space == 1 ? true : false
                        , 'pad-left-2' : x.space == 2 ? true : false
                        , 'pad-left-3' : x.space == 3 ? true : false }">{{ x.text }}
                        </td>
                        <td>
                            <date-picker v-model="form.tax[i].date"
                                         placeholder="วันที่"
                                         :disabled="lockDate"
                                         @change="checkLockDate"
                                         :format="changeFormat"
                                         :lang="lang">
                            </date-picker>
                        </td>
                        <td>
                            <input type="number" class="form-control" v-model="form.tax[i].amount"
                                   @change="calculateVAT(i)">
                        </td>
                        <td>
                            <div class="input-group">
                                <select class="form-control" v-model="form.tax[i].tax_type" @change="calculateVAT(i)">
                                    <option v-for="options in taxType"
                                            :value="options.value">
                                        {{ options.text }}
                                    </option>
                                </select> &nbsp
                                <input type="number" class="form-control" readonly v-model="form.tax[i].tax">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td class="text-right">รวมเงินที่จ่าย และ ภาษีที่นำส่ง</td>
                        <td></td>
                        <td>{{ grand_total | currency }}</td>
                        <td>{{ grand_tax | currency }}</td>
                    </tr>
                </table>
            </div>
            <div class="row my-5">
                <div class="col-6 offset-6 text-center">
                    <button @click="save()"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        บันทึก
                    </button>
                </div>
            </div>
        </div>

        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import Loading from "../../Utility/Loading";
import MaskedInput from 'vue-masked-input'

export default {
    name: "tax-customer-form",
    components: {
        Loading,
        Multiselect,
        VuePagination,
        DatePicker,
        MaskedInput,
    },
    data() {
        return {
            msg: '',
            status_loading: 1,
            items: [
                {
                    text: "หักภาษี ณ ที่จ่าย",
                    to: {name: "tax-customer"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            taxType: [
                {
                    value: "1",
                    text: "1%"
                },
                {
                    value: "3",
                    text: "3%"
                },
                {
                    value: "5",
                    text: "5%"
                },
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionCustomer: [],
            tax_list: [],
            lockDate: false,
        }
    },
    created() {
        this.getCustomerAll();
        this.clearTaxForm();
        this.getTaxList();
    },
    computed: {
        ...mapState({
            form: state => {
                return state.TaxInvoice.form_tax
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        grand_total() {
            return this.form.tax.reduce((total, item) => {
                return total + parseFloat(item.amount ? item.amount : 0);
            }, 0);
        },
        grand_tax() {
            return this.form.tax.reduce((total, item) => {
                return total + parseFloat(item.tax ? item.tax : 0);
            }, 0);
        },
    },
    methods: {
        checkLockDate() {
            let lock = false;
            this.form.tax.forEach(x => {
                if (x.date !== '')
                    lock = true;
            })
            this.lockDate = lock;
        },
        clearDate() {
            this.form.tax.forEach(x => {
                x.date = '';
            })
            this.lockDate = false;
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        customWithName(option) {
            return `${option.name}`
        },
        calculateVAT(i) {
            let tax = 0;
            if (this.form.tax[i].amount && this.form.tax[i].tax_type) {
                tax = this.form.tax[i].tax_type * this.form.tax[i].amount / 100;
            }
            this.form.tax[i].tax = tax;
            return tax;
        },
        getCustomerAll() {
            this.$store.dispatch("TaxInvoice/getCustomerTaxList").then(customers => {
                this.optionCustomer = customers;
            });
        },
        getTaxList() {
            this.$store.dispatch("TaxInvoice/getTaxList").then(res => {
                this.tax_list = res;
            });
        },
        clearTaxForm() {
            this.$store.dispatch("TaxInvoice/clearTaxForm").then(() => {
                if (this.$route.params.id != 'null') {
                    this.lockDate = true;
                    let customer_id = this.$route.query.customer_id ? this.$route.query.customer_id : '';
                    let order = this.$route.query.order ? this.$route.query.order : '';
                    let time = this.$route.query.time ? this.$route.query.time : '';
                    let data = {
                        id: this.$route.params.id,
                        customer_id: customer_id,
                        order: order,
                        time: time
                    }
                    this.$store.dispatch("TaxInvoice/showTaxList", data).then(res => {
                        // setTimeout(function() {
                        if (res.data.length > 0) {
                            this.form.customer = res.data[0].customer;
                            this.form.type = res.data[0].type_main;
                            res.data.forEach((x, i) => {
                                this.form.tax[i].date = x.date;
                                this.form.tax[i].amount = x.amount;
                                this.form.tax[i].tax_type = x.type;
                                this.form.tax[i].tax = this.calculateVAT(i);
                            })
                        }
                        // }, 3000);
                    });
                }
            })
        },
        save() {
            if (this.form.customer) {
                this.status_loading = 1;
                this.msg = 'กำลังโหลด';
                this.showLoadingModal();
                let data = {
                    customer: this.form.customer ? this.form.customer.id : '',
                    type: this.form.type,
                    tax_list: this.form.tax,
                    id: this.$route.params.id != null ? this.$route.params.id : null,
                    user_id: this.user.id
                }
                //format date
                data.tax_list.forEach(x => {
                    x.date = x.date ? moment(x.date).format('YYYY-MM-DD') : '';
                })
                this.$store.dispatch("TaxInvoice/saveTaxCustomer", data).then(() => {
                    this.hideLoadingModal();
                    this.$router.push('/accounting/tax-customer');
                })
            } else {
                this.status_loading = 3;
                this.msg = 'กรุณาเลือกผู้เสียภาษี';
                this.showLoadingModal();
            }
        }
    }
}
</script>

<style scoped>
thead {
    background-color: lightgray;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}

.total-padding {
    padding-right: 20px;
    text-align: right;
}

.pad-left-1 {
    padding-left: 3%;
}

.pad-left-2 {
    padding-left: 6%;
}

.pad-left-3 {
    padding-left: 9%;
}
</style>
